import { z } from 'zod';
import { CurrencyType } from '@dealstack/shared/lib/generated';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types.ts';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';

export enum UPDATE_PROGRAMME_FORM_FIELDS {
	PROGRAMME_NAME = 'programme_name',
	ENTITY_NAME = 'entity_name',
	CURRENCY = 'currency',
	INVESTOR_INSTRUCTIONS = 'investorInstructions',
}

export const UpdateProgrammeShape = (tCommonForm: TranslateFunction<I18Namespaces.COMMON_FORM>) =>
	z.object({
		[UPDATE_PROGRAMME_FORM_FIELDS.PROGRAMME_NAME]: z
			.string({
				message: tCommonForm('field_required'),
			})
			.trim()
			.min(1, tCommonForm('field_required')),
		[UPDATE_PROGRAMME_FORM_FIELDS.CURRENCY]: z.nativeEnum(CurrencyType),
		[UPDATE_PROGRAMME_FORM_FIELDS.INVESTOR_INSTRUCTIONS]: z.string().optional(),
	});

export type UpdateProgrammeFormValues = z.infer<ReturnType<typeof UpdateProgrammeShape>>;

export interface UpdateProgrammeSettingsInputsValues {
	[UPDATE_PROGRAMME_FORM_FIELDS.ENTITY_NAME]: string;
	[UPDATE_PROGRAMME_FORM_FIELDS.PROGRAMME_NAME]: string;
	[UPDATE_PROGRAMME_FORM_FIELDS.CURRENCY]: CurrencyType;
	[UPDATE_PROGRAMME_FORM_FIELDS.INVESTOR_INSTRUCTIONS]: string;
}
